/* eslint-disable no-unused-vars */

import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Modal, Row} from 'react-bootstrap';
import {BiEdit, BiTrash} from 'react-icons/bi';
import {Post} from '../../lib/Request';
import {ALERT_VARIANT, ERoleId} from '../../const/dataEnum';
import {useDispatch} from 'react-redux';
import {setAlert} from '../../stores/actions/alertModalStateAction';
import {API_ACTION, API_ROLE} from '../../const/Api';
import {FmlxTable} from 'fmlx-common-ui';
import {getDefaultValue} from '../../lib/utilities';
import './ManageRoles.scss';

export default function ManageRoles({userRoleId, roles, fetchRoles}) {
  const dispatch = useDispatch();

  const defaultRole = getDefaultValue('role');

  const [roleName, setRoleName] = useState('');
  const [roleID, setRoleID] = useState(0);
  const [action, setAction] = useState('');
  const [loadingModify, setLoadingModify] = useState(false);

  function callError(result) {
    if (result.responseCode !== 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
      return true;
    }
    return false;
  }

  function validateEntry() {
    return roleName?.length > 0;
  }

  async function ModifyRole(event) {
    event.preventDefault();
    setLoadingModify(true);

    let param = {...defaultRole};
    let url;
    // eslint-disable-next-line default-case
    switch (action) {
      case 'Create':
        param.roleName = roleName;
        url = API_ROLE + API_ACTION.CREATE;
        break;
      case 'Update':
        param.roleName = roleName;
        param.id = roleID;
        url = API_ROLE + API_ACTION.UPDATE;
        break;
      case 'Delete':
        param.id = roleID;
        url = API_ROLE + API_ACTION.DELETE;
        break;
    }
    let result = await Post(url, param);
    if (!callError(result)) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: result.message}));
      await fetchRoles();
    } else if (result.responseCode === -9) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: action.Equals('Delete')
            ? `Role ${roleName} cannot be deleted because there is/are employee(s) associated with the ${roleName} role`
            : 'The data is invalid',
        })
      );
    } else {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
    }
    setAction('');
    setRoleID(defaultRole.id);
    setRoleName(defaultRole.roleName);
    setLoadingModify(false);
  }

  const deletePrompt = (
    <Modal show={action === 'Delete'} centered size="md" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <Modal.Title>Delete Role</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure to delete this role?</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={ModifyRole} disabled={loadingModify}>
          {loadingModify ? (
            <div>
              <span
                style={{marginLeft: '0px'}}
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            'Yes'
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            setAction('');
            setRoleID(0);
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const createOrUpdatePrompt = (
    <Modal
      show={['Create', 'Update'].includes(action)}
      centered
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Form onSubmit={ModifyRole}>
        <Modal.Header>
          <Modal.Title>{action} Role</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row g-3>
            <Col>
              <Form.Group size="lg" controlId="username" className="mb-2">
                <Form.Label>Role Name</Form.Label>
                <Form.Control
                  autoFocus
                  placeholder="Role"
                  type="text"
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button size="md" type="submit" style={{width: '150px'}} disabled={!validateEntry() || loadingModify}>
            {loadingModify ? (
              <div>
                <span
                  style={{marginLeft: '0px'}}
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              'Save Changes'
            )}
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              setAction('');
              setRoleID(defaultRole.id);
              setRoleName(defaultRole.roleName);
            }}
            disabled={loadingModify}
          >
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );

  const getSelectedRow = (selectedItems, selectedRowIds) => {
    if (selectedItems.length > 0) {
      setRoleID(selectedItems[0].id);
    }
  };

  return (
    <div className="manage-role-container">
      <div className="manage-role">
        <div>
          <h4>Role</h4>
        </div>
        <div className="manage-role--button-container">
          <Button onClick={() => setAction('Create')}>Add Role</Button>
        </div>
        <div className="manage-role--table-container">
          <FmlxTable
            data={roles}
            getSelectedRow={getSelectedRow}
            // isLoading={loadingRoles}
            columns={[
              {
                Header: 'No',
                accessor: null,
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '20%',
                  minWidth: '20%',
                  maxWidth: '20%',
                },
                Cell: ({value, row}) => {
                  return <>{row.index + 1}</>;
                },
              },
              {
                Header: 'Role',
                accessor: 'roleName',
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '40%',
                  minWidth: '40%',
                  maxWidth: '40%',
                },
              },
              {
                Header: 'Action',
                accessor: null,
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '40%',
                  minWidth: '40%',
                  maxWidth: '40%',
                },
                Cell: ({value, row}) => {
                  const {original} = row;
                  return (
                    <div style={{display: 'flex', gap: '8px'}}>
                      <Button
                        onClick={() => {
                          setRoleID(original.id);
                          setRoleName(original.roleName);
                          setAction('Update');
                        }}
                      >
                        <BiEdit />
                      </Button>
                      {userRoleId === ERoleId.ADMINISTRATOR ? (
                        <Button
                          variant="danger"
                          onClick={() => {
                            setRoleID(original.id);
                            setRoleName(original.roleName);
                            setAction('Delete');
                          }}
                        >
                          <BiTrash />
                        </Button>
                      ) : (
                        <></>
                      )}
                    </div>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
      {deletePrompt}
      {createOrUpdatePrompt}
    </div>
  );
}
